module.exports = __webpack_public_path__ + "img/9788952753632.2a0efa7d.jpg";